import { HttpClient } from '@angular/common/http'
import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core'
import { adobeLaunch } from 'vg-iig-adobe-launch'

import {
  AGGREGATE_VIEWS,
  FUND_LITERATURE,
  FUND_PERFORMANCE,
  LOGGED_IN,
  LOGGED_OUT,
  MONTH_END_RETURN_MARKET_ETF,
  PAGE_ID,
  PERFORMANCE,
  PERFORMANCE_MARKET_ETF,
  PERFORMANCE_VALUE,
  RETURN_TYPE_MONTH_END,
  SECTION,
  SUB_SECTION,
  TAB_NAME,
  USER_DETECTED,
} from '../../../constants/constant.content'
import { NUMBER_FIVE_HUNDRED } from '../../../constants/constant.numbers'
import { ObservableService } from '../../services/observable-service/observable.service'
import { UserLogonService } from '../../services/user-logon/user-logon.service'
import { FilterModel } from '../../shared/filter-model'

@Component({
  selector: 'view-type',
  templateUrl: './view-type.component.html',
  styleUrls: ['./view-type.component.scss'],
})
export class ViewTypeComponent implements OnInit, AfterViewInit {
  @Input() fd3tableContentList: any
  @Input() viewType: string
  @Input() fundLiteratureContentServiceError: boolean
  @Input() isFundLiteratureNoData: any
  @Input() toggleOn: boolean
  @ViewChild('tabContainer', { static: false }) tabContainer: ElementRef

  prevDropdownAdobe = undefined
  userDetailsData: any
  selectedFilter: any = {
    selectedTab: PERFORMANCE_VALUE,
    toggleOn: false,
    returnType: RETURN_TYPE_MONTH_END,
    selectedName: TAB_NAME,
  }
  clickedTab: string
  protected readonly fundLiterature = FUND_LITERATURE
  protected readonly performance = PERFORMANCE
  isFundLiteratureDataAvailable = false
  isLoggedOn = false

  constructor(
    private readonly observableService: ObservableService,
    private readonly userLogonService: UserLogonService,
    private http: HttpClient,
    private readonly filterModel: FilterModel,
  ) {
    this.isLoggedOn = this.userLogonService?.userLogonData?.isLoggedOn
  }

  ngOnInit(): void {
    this.observableService.viewTypeValue.subscribe((displayTypeName) => {
      this.selectedFilter = this.filterModel.setFilter(displayTypeName)
      if (this.prevDropdownAdobe === undefined) {
        this.callPageLoadAdobe()
        this.prevDropdownAdobe = this.viewType
      }
    })

    this.observableService.isFundLiteratureContentValueAvailable.subscribe(
      (value) => {
        this.isFundLiteratureDataAvailable = value
      },
    )

    this.observableService.toggleOnValue.subscribe((value) => {
      this.toggleOn = value
    })
  }

  ngAfterViewInit(): void {
    const performanceTabElem = this.tabContainer.nativeElement.querySelector(
      '#tab-monthEndReturnNAV',
    )
    const literatureTabElem =
      this.tabContainer.nativeElement.querySelector('#tab-literature')

    if (performanceTabElem) {
      performanceTabElem.setAttribute('data-rpa-tag-id', 'performance-tab')
    }

    if (literatureTabElem) {
      literatureTabElem.setAttribute('data-rpa-tag-id', 'fundLiterature-tab')
    }
  }

  displayTable(path: any) {
    if (
      this.viewType !== PERFORMANCE_MARKET_ETF ||
      path !== PERFORMANCE_MARKET_ETF
    ) {
      this.updateViewTypeAndClickedTab(path)
    }
    this.trackSubpageView()
    this.updateSelectedFilter()
    this.onSelectionChange()
  }

  private updateViewTypeAndClickedTab(path: any) {
    if (this.isPerformancePath(path)) {
      this.updatePerformanceViewType()
    } else if (path === FUND_LITERATURE) {
      this.clickedTab = FUND_LITERATURE
    }
  }

  private isPerformancePath(path: any): boolean {
    return path === PERFORMANCE
  }

  private updatePerformanceViewType() {
    if (this.toggleOn) {
      this.clickedTab = FUND_PERFORMANCE
      this.viewType = MONTH_END_RETURN_MARKET_ETF
    } else {
      this.clickedTab = FUND_PERFORMANCE
      this.viewType = PERFORMANCE
    }
  }

  private trackSubpageView() {
    adobeLaunch.trackSubpageViewed(this.clickedTab, true)
  }

  private updateSelectedFilter() {
    this.selectedFilter.selectedTab = this.viewType
    this.selectedFilter.selectedName = this.viewType
  }

  onSelectionChange() {
    this.checkIsPerformanceSelected()
    if (this.clickedTab === FUND_LITERATURE) {
      this.viewType = FUND_LITERATURE
    }
    this.observableService.changeViewTypeValue(this.viewType)
  }

  checkIsPerformanceSelected() {
    if (this.viewType === PERFORMANCE_VALUE) {
      if (this.selectedFilter.returnType === '') {
        this.selectedFilter.returnType = RETURN_TYPE_MONTH_END
      }
    }
  }

  callPageLoadAdobe() {
    if (this.userDetailsData) {
      adobeLaunch.initializePage({
        siteSection1: SECTION,
        siteSection2: SUB_SECTION,
        subPage1: PAGE_ID,
        pageTitle: document.title,
        userDetected: this.userDetailsData,
        subPageId: FUND_PERFORMANCE,
        spClicked: false,
        pageTemplate: AGGREGATE_VIEWS,
      })
    } else {
      setTimeout(() => {
        this.callLoggedOn()
      }, NUMBER_FIVE_HUNDRED)
    }
  }

  callUserDetected() {
    const httpOptions = {
      headers: {
        Accept: 'application/json',
      },
      withCredentials: true,
    }
    this.http.get<any>(adobeLaunch.userDetailsUrl, httpOptions).subscribe({
      next: (response) => {
        const userData = response
        this.userDetailsData = userData
        const userDetected = {
          event: USER_DETECTED,
          user: {
            sPOID: userData.sPOID,
            crmContactID: userData.siebelContactId,
            crewsPOID: userData.sPOID,
            loginStatus: LOGGED_IN,
            businessLine: userData.businessLine,
            crmCompanyNumber: userData.siebelCompanyNo,
            companyTier: userData.companyTier,
          },
        }
        adobeLaunch.initializePage({
          siteSection1: SECTION,
          siteSection2: SUB_SECTION,
          subPage1: PAGE_ID,
          pageTitle: document.title,
          userDetected: userDetected,
          subPageId: FUND_PERFORMANCE,
          spClicked: false,
          pageTemplate: AGGREGATE_VIEWS,
        })
      },
      error: (error) => {
        const userDetected = {
          event: USER_DETECTED,
          user: {
            loginStatus: LOGGED_OUT,
          },
        }
        adobeLaunch.initializePage({
          siteSection1: SECTION,
          siteSection2: SUB_SECTION,
          subPage1: PAGE_ID,
          pageTitle: document.title,
          userDetected: userDetected,
          subPageId: FUND_PERFORMANCE,
          spClicked: false,
          pageTemplate: AGGREGATE_VIEWS,
        })

        console.error('When User Detected Failed`!', error)
      },
    })
  }

  callLoggedOn() {
    if (adobeLaunch.userDetailsUrl) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (this.isLoggedOn === true) {
        this.callUserDetected()
      } else {
        const userDetected = {
          event: USER_DETECTED,
          user: {
            loginStatus: LOGGED_OUT,
          },
        }
        adobeLaunch.initializePage({
          siteSection1: SECTION,
          siteSection2: SUB_SECTION,
          subPage1: PAGE_ID,
          pageTitle: document.title,
          userDetected: userDetected,
          subPageId: FUND_PERFORMANCE,
          spClicked: false,
          pageTemplate: AGGREGATE_VIEWS,
        })
      }
    }
  }
}
